import classNames from 'classnames';
import { MouseEvent, ReactNode, useCallback } from 'react';
import { Button, ButtonProps, attempt } from 'yoso';
import { CelectContextValue, useCelect } from '~/components/Form/Celect/Celect.hooks';
import triangle from '~/components/Icon/Triangle.svg';
import styles from './CelectButton.module.scss';

export type CelectButtonProps = ButtonProps & {
  icon?: ReactNode;
  children?: ReactNode | ((context: CelectContextValue) => ReactNode);
};
export const CelectButton = ({
  className,
  onClick,
  children,
  icon = (
    <img
      className={styles.icon}
      src={triangle}
      width="28"
      height="28"
      alt="triagle"
      aria-label="icon"
    />
  ),
  ...props
}: CelectButtonProps) => {
  const context = useCelect();
  const { toggle } = context;
  const handleClick = useCallback(
    (event: MouseEvent) => {
      onClick?.(event);
      toggle();
    },
    [onClick, toggle]
  );
  return (
    <Button
      className={classNames(styles.root, { [styles.active]: context.active }, className)}
      onClick={handleClick}
      {...props}>
      {attempt(children, context)}
      {icon}
    </Button>
  );
};
